DO.Subscribe(['app:ready'], () => {
  function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
      : null;
  }

  function getElementFontColor(classList) {
    if (classList.contains('text--dark')) {
      return '#222222';
    } if (classList.contains('text--light')) {
      return '#FFFFFF';
    }
    return null;
  }

  document.querySelectorAll('span.highlight').forEach((item) => {
    const fontColor = getComputedStyle(
      document.documentElement,
    ).getPropertyValue('--blogPostFont');
    const parent = item.closest('.element');
    const elementFontColor = getElementFontColor(parent.classList);
    const themeColor = elementFontColor || fontColor || '#222222'; // Will need update once we have colour options for wider pages

    const rgb = hexToRgb(themeColor.trim());
    if (rgb) {
      item.style.backgroundColor = `rgba(${rgb.r},${rgb.g},${rgb.b}, 0.3)`; // eslint-disable-line no-param-reassign
    }
  });
});
